module.exports = __webpack_public_path__ + "img/downLoad.8a10fcbc.png";